import { getConstant } from '../utils';

export const getCalculatorsDegreeOfSoil = getConstant('GET_CALCULATORS_DEGREE_OF_SOIL');
export const getCalculatorsDegreeOfSoilItem = getConstant('GET_CALCULATORS_DEGREE_OF_SOIL_TYPE');